"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentContext = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useComponentContext = (componentName) => {
    const context = (0, react_1.useContext)(context_1.UiContext);
    if (typeof context === "undefined") {
        throw new Error(`If you want to use the "${componentName}" UI component, you have to wrap your code in the "UiContextProvider"`);
    }
    return context[componentName];
};
exports.useComponentContext = useComponentContext;
